<template>
  <footer class="card">
    <div class="card-body p-125">
      <div class="ml-auto mt-2 mt-lg-0 d-flex justify-content-end">
        <div id="msg-wrapper" class="d-flex justify-content-end mx-3">
          <div id="save-processing" class="align-self-center text-secondary">
            <i class="fas fa-hourglass-half mx-2"></i>
            <span class="fs">{{ __('equipment.save_pending') }}</span>
          </div>
          <div id="save-success" class="mask align-self-center text-success">
            <i class="fas fa-circle-check mx-2"></i
            ><span class="fs">{{ __('equipment.save_success') }}</span>
          </div>
          <div id="save-error" class="mask align-self-center text-danger">
            <i class="fas fa-triangle-exclamation mx-2"></i
            ><span class="fs">{{ __('equipment.save_error') }}</span>
          </div>
        </div>
        <button class="button-right btn btn-secondary text-nowrap" @click="$emit('cancel')">
          {{ __('message_interface.btns.cancel') }}
        </button>
        <button class="btn ml-2 button-save btn-success" @click="$emit('save')">
          {{ __('message_interface.btns.save') }}
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'EquipmentBottomBar',
  emits: ['cancel', 'save']
}
</script>

<style>
.p-125 {
  padding: 1.25rem;
}

#save-success,
#save-processing,
#save-error {
  display: none;
}

#msg-wrapper {
  width: 35%;
}

.fs {
  font-size: 0.8rem;
}
</style>
